// Pestaña Pagos: el libro de pagos del crédito (motor y tienda), del más reciente al más viejo, y
// arriba cuánto ha pagado el cliente y cuánto de eso abonó a capital.
import { formatDateTimeMx } from '@/lib/dateHelpers';
import { useCreditPayments } from '../../installments/api/useCreditPayments';
import { InstallmentPaymentsTab } from '../../installments/components/InstallmentPaymentsTab';
import {
    appliedTotalOf,
    formatPaymentCents,
    paymentKindLabelOf,
} from '../../installments/payments';
import { paymentOriginFactsOf } from '../../payments/paymentOrigin';
import { CreditBlock, CreditCard, CreditKeyValue } from './CreditFileUi';

const NO_PAYMENTS = 'Todavía no hay pagos';

function countOf(count: number, one: string, many: string): string {
    return count === 1 ? `1 ${one}` : `${String(count)} ${many}`;
}

export interface CreditPaymentsTabProps {
    creditId: string;
}

export function CreditPaymentsTab({ creditId }: CreditPaymentsTabProps) {
    const payments = useCreditPayments(creditId);
    const rows = payments.payments;
    const latest = rows.at(0);
    const prepayments = rows.filter((row) => row.chargeKind === 'PREPAYMENT');
    // Con páginas sin cargar, los totales son de lo cargado: se dice.
    const partial = payments.hasNextPage ? ' · hay más por cargar' : '';

    return (
        <>
            <CreditCard title="Resumen de pagos">
                <CreditBlock
                    isLoading={payments.isLoading}
                    failure={payments.failure}
                    subject="los pagos"
                    onRetry={payments.retry}
                >
                    <CreditKeyValue
                        label="Último pago"
                        value={
                            latest
                                ? `${formatDateTimeMx(latest.appliedAt)} · ${formatPaymentCents(latest.appliedCents, latest.currency)} · ${paymentKindLabelOf(latest)} · ${paymentOriginFactsOf(latest).where}`
                                : NO_PAYMENTS
                        }
                    />
                    <CreditKeyValue
                        label="Total pagado"
                        value={
                            rows.length > 0
                                ? `${appliedTotalOf(rows)} · ${countOf(rows.length, 'pago', 'pagos')}${partial}`
                                : NO_PAYMENTS
                        }
                    />
                    <CreditKeyValue
                        label="Abonos a capital"
                        value={
                            prepayments.length > 0
                                ? `${appliedTotalOf(prepayments)} · ${countOf(prepayments.length, 'abono', 'abonos')}${partial}`
                                : 'Ninguno'
                        }
                    />
                </CreditBlock>
            </CreditCard>

            <CreditCard title="Pagos aplicados">
                <InstallmentPaymentsTab payments={payments} showHeading={false} />
            </CreditCard>
        </>
    );
}
